module.exports = __webpack_public_path__ + "img/cine-documental-y-storytelling_info.1d84a419.jpg";